import { Messages } from '../../codegen/Localize';
import { ToasterService, ToastType } from '../../ts/services/ToasterService';
import { IMetricInfo } from '../models/IMetricInfo';
import { Metrics } from '../resources/Metrics';

export namespace ResumeMetricAction {
  export async function resumeMetric(metric: IMetricInfo, isOwner: boolean) {
    const result = await Metrics.resumeMetrics([metric.id]);
    if (!result.errors) {
      ToasterService.instance.pop({
        type: ToastType.Success,
        text: Messages.metricResumeSuccess({ METRIC_NAME: metric.name, }),
        testId: 'resume-metric-success'
      });
    } else if(result.errors[0].code === 300007) {
      if(isOwner) {
        throw new Error(Messages.metricResumeErrorMessageUserCantCreateRefreshMetricSelf());
      } else {
        throw new Error(Messages.metricResumeErrorMessageUserCantCreateRefreshMetricOther());
      }
    } else {
      throw new Error(Messages.metricResumeErrorMessage());
    }
  }
}
